import React, { useEffect, useState } from "react";

import {
    houseToGrid,
    pannelToGrid,
    pannelToHouse,
} from "../../resources/js/gifs";
import {
    gridDis,
    home,
    homeToGridDis,
    homeToPanelDis,
    houseDis,
    panelToGridDis,
    pannelDis,
    powerGrid,
    solarPanel,
} from "../../resources/js/icons";

const PannelAnimation = ({ projectEnable }) => {
    const [gifs, setGifs] = useState({
        houseToGrid: homeToGridDis,
        pannelToGrid: panelToGridDis,
        pannelToHouse: homeToPanelDis,
    });

    useEffect(() => {
        if (!projectEnable) return;
        const updateGifs = () => {
            const currentHour = new Date().getHours();

            if (currentHour >= 7 && currentHour < 17) {
                setGifs({
                    houseToGrid: homeToGridDis,
                    pannelToGrid: pannelToGrid,
                    pannelToHouse: pannelToHouse,
                });
            } else {
                setGifs({
                    houseToGrid: houseToGrid,
                    pannelToGrid: panelToGridDis,
                    pannelToHouse: homeToPanelDis,
                });
            }
        };

        if (projectEnable) {
            updateGifs();
            const intervalId = setInterval(updateGifs, 60000);

            return () => clearInterval(intervalId);
        }
    }, [projectEnable]);
    return (
        <>
            <div className="flex justify-between items-center gap-1.5">
                <img
                    src={projectEnable ? home : houseDis}
                    alt="home"
                    className="w-20 md:w-32"
                />
                <img
                    src={gifs.houseToGrid}
                    alt="house_to_grid"
                    className="w-1/2"
                />
                <img
                    src={projectEnable ? powerGrid : gridDis}
                    alt="power_grid"
                    className="w-20 md:w-32"
                />
            </div>
            <div className="flex justify-between items-center gap-1 mx-3">
                <img
                    src={gifs.pannelToHouse}
                    alt="pannel_to_house"
                    className="w-20 md:w-36"
                />
                <div className="flex flex-col justify-center items-center">
                    <p className="text-white md:text-secondary text-center text-xs">
                        Grid Connected System
                    </p>

                    <img
                        src={projectEnable ? solarPanel : pannelDis}
                        alt="solar_panel"
                        className="w-20 md:w-44 mt-3"
                    />
                </div>
                <img
                    src={gifs.pannelToGrid}
                    alt="pannel_to_grid"
                    className="w-20 md:w-36"
                />
            </div>
        </>
    );
};

export default PannelAnimation;
